export default __webpack_public_path__ + "static/media/shailesh.58e2d5de.jpeg";